<template>
  <div class="footer">
    <payPage ref="pay"></payPage>
    <!-- pc端样式 -->
    <div class="footer_PC">
      <div class="footer_up">
        <div class="footer_l">
          <img src="../../assets/images/logo_01.png" alt="">
          <span class="needClass">Next-generation network architecture and NaaS innovation and leadership</span>
          <a href="javascript:void(0);" class="comButton collection-1 btn-15"><span>Consultation hotline</span></a>
          <strong>4000-810-510</strong>
          <p>Monday to Friday 9:00-18:00</p>
          <p>Company Address: 16th Floor, Building 3, Wangjing Chengying Center, Chaoyang District, Beijing</p>
        </div>
        <!-- <div class="footer_r">
          <div v-for="(item,index) in listArr" :key="index">
            <h6>{{ item.name }}</h6>
            <ul>
              <li v-for="(items,indexs) in item.articleList" :key="indexs" @click="tolink(item,item.path,items.id,items)">{{ items.title }}</li>
            </ul>
          </div>
        </div> -->
      </div>
      <div class="footer_line"></div>
      <div class="footer_down">
        <p>Website Maintenance：鼐特（北京）信息技术有限公司&nbsp;&nbsp;/&nbsp;&nbsp;<a href="https://www.magnetworks.cn/agreement/magsase-privacy-en.html" target="blank">Privacy Policy</a></p>
        <p>Company address:Floor 16, Building 3, Wangjing Chengying Center, Chaoyang District, Beijing</p>
        <p class="havelink"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="blank">京ICP备2022011624号-2</a></p>
      </div>
    </div>
    <!-- 移动端样式 -->
    <div class="footer_mobile">
      <img src="../../assets/images/logo_01.png" alt="">
      <h4>Next-generation network architecture and NaaS innovation and leadership</h4>
      <!-- <div class="fM_list">
        <div v-for="(item,index) in listArr" :key="index">
          <h6 @click="showAllLi(index)">
            <p>{{ item.name }}</p>
            <i v-if="item.articleList && item.articleList.length > 0" :class="item.showAll ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
          </h6>
          <ul v-show="item.showAll">
            <li v-for="(items,indexs) in item.articleList" :key="indexs" @click="tolink(item,item.path,items.id,items)">{{ items.title }}</li>
          </ul>
        </div>
      </div> -->
      <div class="fM_phone">
        <div class="fM_phoneH">
          <a href="javascript:void(0);" class="comButton collection-1 btn-15"><span>Consultation hotline</span></a>
          <p>4000-810-510</p>
        </div>
        <div class="fM_work">
          <p>Monday to Friday  9:00-12:00   4:00-18:00</p>
          <p>Company address:Floor 16, Building 3, Wangjing Chengying Center, Chaoyang District, Beijing</p>
        </div>
      </div>
      <div class="fM_bottom">
        <p>Website Maintenance：鼐特（北京）信息技术有限公司</p>
        <p>Floor 16, Building 3, Wangjing Chengying Center, Chaoyang District, Beijing</p>
        <p class="havelink"><a href="https://beian.miit.gov.cn/#/Integrated/index" target="blank">京ICP备2022011624号-2</a></p>
      </div>
    </div>
  </div>
</template>

<script>
import payPage from '@/components/comForPc/payPage.vue'
export default {
  components: { payPage },
  data () {
    return {
      listArr: []
    }
  },
  methods: {
    // 获取导航数据
    getNavList () {
      this.$axios.get('/blog/api/getcategorys')
        .then(res => {
          let arr = []
          res.data.forEach(item => {
            if (item.id !== 1 && item.id !== 4 && item.articleList && item.articleList.length > 0) {
              console.log(item)
              arr.push(item)
            }
          })
          res.data.forEach(item => {
            if (item.articleList.length > 0) {
              item.showAll = false
            }
          })
          this.listArr = arr
        }).catch(err => {
          console.log(err)
        })
    },
    tolink (item, path, id, items) {
      if (items.charge !== 0) {
        this.$refs.pay.showDialog()
        return
      }
      if (path === '/news') {
        path = '/newsInfo'
        this.$router.push({path: path, query: {id: id}})
        return
      }
      path ? this.$router.push({path: path, query: {id: item.id, childId: id}}) : this.$router.push({path: item.path, query: {id: item.id}})
    },
    showAllLi (index) {
      console.log(this.listArr[index])
      if (this.listArr[index].articleList.length === 0) {
        return
      }
      this.listArr[index].showAll = !this.listArr[index].showAll
    }
  },
  created () {
    this.getNavList()
  },
  destroyed () {

  }
}
</script>
<style lang="less" scoped>
.havelink{
  color: #1bb0ce;
}
// 移动端样式
@media only screen and (max-width: 1024px) {
  .footer_PC{
    display: none;
  }
  .comButton{
    color: #fff;
    border-radius:28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
    padding: 0;
    height:50px;
    font-size: 16px;
    cursor: auto;
  }
  .btn-15:after{
    background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
  }
  .footer_mobile{
    width: 100%;
    background: #2D2D2D;
    padding: 1.8rem 1.5rem 3.25rem;
    img{
      width: 7rem;
      margin-bottom: 0.5rem;
    }
    h4{
      font-size: 0.9375rem;
      font-weight: 600;
      color: #FFFFFF;
      text-indent: 2.875rem;
      border-bottom: 0.125rem solid #616161;
      padding-bottom: 1.25rem;
    }
    .fM_list{
      div{
        border-bottom: 0.125rem solid #616161;
        h6{
          font-size: 0.9375rem;
          font-weight: 600;
          color: #FFFFFF;
          padding: 1rem 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        ul{
          li{
            font-size: 0.875rem;
            font-weight: 300;
            color: #A8A8A8;
            text-indent: 1.25rem;
            margin-bottom: 0.6rem;
          }
        }
      }
    }
    .fM_phone{
      padding: 1.25rem 0 1.25rem;
      border-bottom: 0.125rem solid #616161;
      .fM_phoneH{
        display: flex;
        p{
          font-size: 1.5rem;
          font-weight: 800;
          color: #44A2FF;
          margin-left: 1rem;
        }
      }
      .btn-15{
        border-radius: 0 1rem 1rem 1rem;
        margin: 0;
        height: 1.875rem;
        font-size: 0.8125rem;
        width: 5rem;
      }
      .btn-15:after{
        background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
      }
      .fM_work{
        p{
          font-size: 0.75rem;
          font-weight: 300;
          color: #A8A8A8;
          margin-top: 0.7rem;
        }
      }
    }
    .fM_bottom{
      padding-top: 1.56rem;
      text-align: center;
      font-size: 0.6875rem;
      font-weight: 300;
      color: #BEC0C5;
      line-height: 1rem;
    }
  }
}
// pc端样式
@media only screen and (min-width: 1024px) {
  .footer_mobile{
    display: none;
  }
  .comButton{
    color: #fff;
    border-radius:28px;
    cursor: pointer;
    overflow: hidden;
    background-image: linear-gradient(228deg,#3EE3FF,#2E9EFD 41%,#186AE8);
    padding: 0;
    height:50px;
    font-size: 16px;
    cursor: auto;
    margin-left: 0;
  }
  .btn-15:after{
    background-image: linear-gradient(315deg,#0027C2 0,#209DFF 74%);
  }
  .footer{
    width: 100%;
    box-sizing: border-box;
    background: #2D2D2D;
    padding:46px 0;
    color: #fff;
    .footer_PC{
      max-width: 1180px;
      margin:0 auto;
    }
    .footer_up{
      display: flex;
      .footer_l,.footer_r{
        width: 50%;
      }
      .footer_l{
        span,strong{
          display: block;
        }
        img{
          width: 162px;
          height: 60px;
          margin-bottom: 25px;
        }
        .needClass{
          font-size: 20px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 30px;
          margin-bottom: 86px;
        }
        strong{
          font-size: 30px;
          font-weight: 800;
          color: #44A2FF;
          margin: 10px 0;
        }
        p{
          font-size: 14px;
          font-weight: 400;
          color: #A8A8A8;
          margin-bottom: 10px;
        }
      }
      .footer_r{
        display: flex;
        justify-content: space-around;
        div{
          h6{
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 29px;
          }
          ul{
            max-width: 160px;
            li{
              font-size: 14px;
              font-weight: 400;
              color: #A8A8A8;
              margin-bottom: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              display:-webkit-box;
              -webkit-box-orient:vertical;
              -webkit-line-clamp:2;
              cursor: pointer;
            }
            li:hover{
              color: #428BF8;
            }
          }
        }
      }
    }
    .footer_line{
      width: 100%;
      height: 2px;
      background: #616161;
      border-radius: 2px;
      margin: 57px 0 39px;
    }
    .footer_down{
      text-align: center;
      font-size: 12px;
      font-weight: 300;
      color: #BEC0C5;
      p{
        margin-bottom: 6px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/footer_English.vue